import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SignupHeaderComponent } from '../ui/signup-header.component';
import { SignupErrorComponent } from './signup-error.component';
import { SignupResetService } from '../signup-reset.service';

export const TOO_MANY_REQUESTS_MESSAGE = 'Too many requests, please try again after 15 minutes.';

/** /too-many-requests: where a throttled (429) customer-intake request lands (see signupThrottleInterceptor). */
@Component({
  selector: 'app-too-many-requests',
  imports: [SignupHeaderComponent, SignupErrorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: '../signup-theme.css',
  template: `
    <app-signup-header />
    <main><app-signup-error tone="wait" [message]="message" /></main>
  `,
})
export class TooManyRequestsComponent {
  protected readonly message = TOO_MANY_REQUESTS_MESSAGE;

  constructor() {
    // Clear what this visit entered (stores and storage), as /enrolled does. Here rather than in the interceptor,
    // so /signup isn't re-rendered without its address (→ a flash of the waitlist) before this page replaces it.
    inject(SignupResetService).reset();
  }
}
